// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-template template-btn\"> <i class=\"fa fa-file\"></i> Template </a>";
// Exports
export default code;